import { StripePlanId } from '@/types/StripePlanId'
import { MembershipPlan } from '@/types/membershipPlan'
import { MembershipTerm } from '@/types/membershipTerm'

export type GetStripePlanIdParams = {
  plan: MembershipPlan
  term: MembershipTerm
  currency: 'CAD' | 'USD'
}

export const getStripePlanId = (
  params: GetStripePlanIdParams
): StripePlanId => {
  const { plan, term, currency } = params

  if (plan === 'apprentice') {
    if (term === 'monthly') {
      return currency === 'CAD' ? 'level_2_monthly_cad' : 'level_2_monthly'
    } else {
      return currency === 'CAD' ? 'level_2_yearly_cad' : 'level_2_yearly'
    }
  }
  if (plan === 'builder') {
    if (term === 'monthly') {
      return currency === 'CAD' ? 'level_3_monthly_cad' : 'level_3_monthly'
    } else {
      return currency === 'CAD' ? 'level_3_yearly_cad_2' : 'level_3_yearly_2'
    }
  }

  throw new Error(
    `Invalid stripe plan request for plan: ${plan}, ${term}, ${currency}`
  )
}
